import { render, staticRenderFns } from "./RelationshipEdit.vue?vue&type=template&id=d42fa540&scoped=true&"
import script from "./RelationshipEdit.vue?vue&type=script&lang=js&"
export * from "./RelationshipEdit.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipEdit.vue?vue&type=style&index=0&id=d42fa540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42fa540",
  null
  
)

export default component.exports